<template>
  <v-container grid-list-xs class="pt-0 px-3">
    <v-layout row style="padding-left: 60px;" wrap>
      <v-flex
        v-for="(item, index) in activity.activity_count"
        :key="item"
        :class="gridClass(item, activity.activity_count)"
        @click="$emit('open-asset', getObject(index))"
      >
        <v-card  tile class="d-flex" nuxt>
          <div class="v-responsive v-image img-border hover-darken">
            <div class="v-responsive__sizer " style="padding-bottom: 100%;" />
            <div
              v-lazy:background-image="getSource(index)"
              style="background-position: center center;  z-index:1"
              class="v-image__image v-image__image--cover lazy"
            />
          </div>
        </v-card>
        <div v-if="index == 5" class="more-container">
          <v-flex fill-height d-flex justify-center align-center>
            <div v-if="index > 5" class="display-1 text-center">
              +{{ activity.activity_count - 5 }}
            </div>
          </v-flex>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'ActivityCardAsset',
  props: {
    activity: {
      type: [Object],
      required: true,
      default: () => ({})
    },
    getCardUser: {
      type: [Object],
      required: true,
      default: () => ({})
    },
    getObject: {
      type: [Function],
      required: false,
      default: function() {}
    }
  },
  methods: {
    gridClass(n, total) {
      if (total == 4) {
        return 'xs6'
      }
      if (total > 4) {
        if (n == 1 || n == 2) {
          return 'xs6'
        }
        if (n == 5) {
          return 'relative'
        }
        if (n > 5) {
          return 'hide'
        }
      }
    },
    getSource(index) {
      return this.getObject(index)._thumbnail
    },
    openDialog(index) {
      console.log(this.$refs)
    }
  }
}
</script>
